import Calendar from 'react-calendar';
import 'react-calendar/dist/Calendar.css';
import './CalendarView.css';
import type { MouseEvent } from 'react';
import { isSameDay } from 'date-fns';

type ValuePiece = Date | null;

type Value = ValuePiece | [ValuePiece, ValuePiece];

export const CalendarView = (
  {
    onChange,
    value,
    highlightedDates = [],
    onMonthChange
  }: {
    onChange: (value: Value, event: MouseEvent<HTMLButtonElement>) => void;
    value: Value;
    highlightedDates?: Date[];
    onMonthChange?: (date: Date) => void;
  }
) => {
  return (
    <div className="pb-4">
      <Calendar
        locale="es-ES"
        onChange={onChange}
        value={value}
        className="mx-auto"
        onClickDay={() => { }}
        minDetail="month"
        maxDetail="month"
        onActiveStartDateChange={({ activeStartDate }) => {
          if (activeStartDate && onMonthChange) {
            onMonthChange(activeStartDate);
          }
        }}
        tileClassName={({ date, view }) =>
          view === 'month' && highlightedDates.some(d => isSameDay(d, date))
            ? 'highlighted-class'
            : null
        }
      />
    </div>
  );
};
